module.exports = __webpack_public_path__ + "img/banner_image02.ec94b75.jpg";